__turbopack_context__.v({
  "button": "SocialButton-module__0Obtea__button",
});
